module.exports = __webpack_public_path__ + "img/mczt-wx2.e63ccc79.jpeg";